import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const MapContainer = styled.div`
    margin-bottom: 8px;
    margin-top: 16px;
  
    img{
      width: 100%;
      min-width: 300px;
      border: 1px solid #D2D5D7;
    }
`;

class Map extends React.Component {
    constructor(props) {
        super(props);
    }

    getMapUrl(){
        const center = `${this.props.lat},${this.props.lng}`;
        const zoom = '13';
        const size = '300x300';
        const markers = `color:red|${center}`;
        const key = process.env.REACT_APP_GOOGLE_STATIC_MAP_KEY;

        return `https://maps.googleapis.com/maps/api/staticmap?center=${center}&zoom=${zoom}&size=${size}&markers=${markers}&key=${key}`;
    }

    render() {
        return (
            <MapContainer>
                <img src={this.getMapUrl()} alt="Google Map"/>
            </MapContainer>
        )
    }
}

Map.propTypes = {
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired
};

export default Map;
